<template>
  <template v-if="type == 'config'">
    <m-search />
    <m-table />
  </template>
  <template v-else>
    <Search />
    <Table />
  </template>
</template>
<script>
import {
  menu_system_list_get,
  menu_delete_post,
  menu_list_get
} from 'server/modules/351.js'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { provide, onMounted, reactive, toRefs, createVNode } from 'vue'
import Search from './components/system/Search'
import Table from './components/system/Table'
import MSearch from './components/menus/Search'
import MTable from './components/menus/Table'
import { message, Modal } from 'ant-design-vue'
import { mergeObject } from 'utils/index.js'

export default {
  name: 'menuManage',
  components: {
    Search,
    Table,
    MSearch,
    MTable
  },
  setup() {
    const state = reactive({
      type: '',
      // 删除
      deleteItem: async (id, callback) => {
        Modal.confirm({
          title: '确定删除本条数据?',
          icon: createVNode(ExclamationCircleOutlined),
          content: '删除之后，享有该菜单权限的人员将无法正常进入系统',
          async onOk() {
            const { success, data } = await menu_delete_post({
              id
            })
            if (success) {
              message.success(data)
              callback()
            }
          }
        })
      }
    })
    // 系统配置
    const systemState = reactive({
      dataList: [],
      visible: false,
      formData: {
        // 系统名称
        menuName: '',
        menuNameEn: '',
        // 系统描述
        menuDesc: '',
        // 系统三字码
        menuCode: '',
        menuPath: '',
        id: '',
        integrationMode: null,
        isGray: 0
      },
      setAttrs: (name, value) => {
        systemState[name] = value
      },

      // 清空
      setEmpty: () => {
        systemState.formData = {
          // 系统名称
          menuName: '',
          menuNameEn: '',
          // 系统描述
          menuDesc: '',
          // 系统三字码
          menuCode: '',
          menuPath: '',
          id: '',
          integrationMode: null,
          isGray: 0
        }
      },
      /**
       * 查询地址列表
       */
      getSystemList: async () => {
        const { success, data } = await menu_system_list_get({})
        if (success) {
          const { list } = data
          systemState.dataList = list
        }
      },

      // 创建系统和编辑系统
      show(text) {
        const { setEmpty, formData, setAttrs } = systemState
        setAttrs('visible', true)
        if (!text) {
          setEmpty()
        } else {
          systemState.formData = mergeObject(formData, text)
        }
      },
      // 菜单配置
      menuConfig(text) {
        const { queryMenuList } = menusState
        const { id, menuCode } = text
        menusState.params.parentId = id
        menusState.systemCode = menuCode
        state.type = 'config'
        queryMenuList()
      }
    })
    // 菜单管理模块
    const menusState = reactive({
      menuList: [],
      visible: false,
      params: {
        parentId: '',
        menuTypeStart: 1
      },
      systemCode: '',
      formData: {
        // 系统名称
        menuName: '',
        menuNameEn: '',
        // 图标
        menuIcon: '',
        // 菜单路径
        menuPath: '',
        parentId: '',
        // 按钮权限code
        menuCode: '',
        // 菜单类型
        menuType: null,
        id: '',
        // 集成模式
        integrationMode: null,
        isGray: 0
      },

      setAttrs: (name, value) => {
        menusState[name] = value
      },
      // 清空
      setEmpty: () => {
        menusState.formData = {
          // 系统名称
          menuName: '',
          menuNameEn: '',
          // 图标
          menuIcon: '',
          // 菜单路径
          menuPath: '',
          // 按钮权限code
          menuCode: '',
          parentId: '',
          // 菜单类型
          menuType: null,
          id: '',
          integrationMode: null,
          isGray: 0
        }
      },

      /**
       * 查询地址列表
       */
      queryMenuList: async () => {
        const { params } = menusState
        const { success, data } = await menu_list_get(params).catch(() => {
          menusState.menuList = []
        })
        if (success) {
          const { list } = data
          menusState.menuList = list
        }
      },
      // 创建和编辑菜单、创建按钮
      show(type, text) {
        const { setAttrs, setEmpty, formData } = menusState
        setAttrs('visible', true)
        if (type === 0) {
          setEmpty()
          menusState.formData.parentId = text
            ? text.id
            : menusState.params.parentId
        } else {
          menusState.formData = mergeObject(formData, text)
        }
      }
    })

    onMounted(() => {
      const { getSystemList } = systemState
      getSystemList()
    })
    provide('state', state)
    provide('menusState', menusState)
    provide('systemState', systemState)

    return {
      ...toRefs(state)
    }
  }
}
</script>
